import type { components } from "@/shared/api";

type PlayerStats = components["schemas"]["PlayerStatsOut"];

// Первый быстрый разбор игрока идёт в фоне: сводка отвечает `pending`, пока он не закончится.
// Перезапрашиваем раз в 5 секунд, но не дольше 2 минут — как ожидание истории матчей.
// Дальше сводку обновит событие `stats.updated` или следующее открытие страницы.
export const STATS_POLL_INTERVAL_MS = 5_000;
export const STATS_POLL_MAX_FETCHES = 24;

export const isStatsPending = (data: PlayerStats | undefined, fetchCount: number): boolean =>
  data?.status === "pending" && fetchCount < STATS_POLL_MAX_FETCHES;
